import './SettingsSection.scss';
import classNames from 'classnames';
import { SonarText } from '@ui/text';
import { When } from 'react-if';
import React from 'react';
export const SettingsSection = ({ children, className, subheading, title }) => {
    const displayTitle = typeof title === 'string' ? React.createElement(SonarText, { className: 'h2' }, title) : title;
    return (React.createElement("div", { className: classNames('settings-section', className) },
        React.createElement("div", { className: 'title' }, displayTitle),
        React.createElement(When, { condition: subheading },
            React.createElement(SonarText, { className: 'subheading' }, subheading)),
        children));
};
